import { Logger } from '../utils/logger';
export class AjaxService {
    constructor(ajaxUrl, nonce) {
        this.ajaxUrl = ajaxUrl;
        this.nonce = nonce;
    }
    /**
     * Get document content after form submission
     * @param postId
     * @param formId
     */
    async getDocumentContent(postId, formId) {
        return this.makeRequest('gpsa_get_document_content', {
            post_id: postId,
            form_id: formId,
        });
    }
    /**
     * Get document form for AJAX loading
     * @param postId
     * @param formId
     * @param contentId
     */
    async getDocumentForm(postId, formId, contentId) {
        return this.makeRequest('gpsa_get_document_form', {
            post_id: postId,
            form_id: formId,
            content_id: contentId,
        });
    }
    /**
     * Get block content after form submission
     * @param postId
     * @param formId
     * @param contentHash
     */
    async getBlockContent(postId, formId, contentHash) {
        return this.makeRequest('gpsa_get_block_content', {
            post_id: postId,
            form_id: formId,
            content_hash: contentHash,
        });
    }
    /**
     * Get block form for AJAX loading
     * @param postId
     * @param formId
     * @param contentId
     */
    async getBlockForm(postId, formId, contentId) {
        return this.makeRequest('gpsa_get_block_form', {
            post_id: postId,
            form_id: formId,
            content_id: contentId,
        });
    }
    /**
     * Get shortcode content after form submission
     * @param postId
     * @param formId
     * @param encryptedShortcode
     */
    async getShortcodeContent(postId, formId, encryptedShortcode) {
        return this.makeRequest('gpsa_get_shortcode_content', {
            post_id: postId,
            form_id: formId,
            encrypted_shortcode: encryptedShortcode,
        });
    }
    /**
     * Get shortcode form for AJAX loading
     * @param formId
     * @param encryptedShortcode
     */
    async getShortcodeForm(formId, encryptedShortcode) {
        return this.makeRequest('gpsa_get_shortcode_form', {
            form_id: formId,
            encrypted_shortcode: encryptedShortcode,
        });
    }
    /**
     * Make AJAX request with error handling
     * @param action
     * @param data
     * @private
     */
    async makeRequest(action, data) {
        const requestData = {
            action,
            _wpnonce: this.nonce,
            ...data,
        };
        try {
            const response = await jQuery.post(this.ajaxUrl, requestData);
            if (!response.success) {
                throw new Error(response.data || 'AJAX request failed');
            }
            return response.data;
        }
        catch (error) {
            Logger.error(`AJAX request failed for action: ${action}`, error);
            throw error;
        }
    }
    /**
     * Show loading error message
     * @param container
     */
    static showLoadingError(container) {
        container
            .html('<p>Error loading form. Please refresh the page.</p>')
            .show();
    }
}
